import { CREATE_EMPLOYEE_LEAVE_ROUTE_ID, APPLIED_EMPLOYEE_LEAVE_ROUTE_ID } from './common';
import CreateLeave from './LeaveManagement/CreateLeave';
import LeaveManagement from './LeaveManagement/LeaveManagement';


export default {
    [CREATE_EMPLOYEE_LEAVE_ROUTE_ID]: () => <CreateLeave />,
    [APPLIED_EMPLOYEE_LEAVE_ROUTE_ID]: () => <LeaveManagement />,
};
